// removed by extract-text-webpack-plugin
module.exports = {"card":"card--card--2x7OZ6zo","card-header":"card--card-header--1Ch1FXyy","cardHeader":"card--card-header--1Ch1FXyy","card-collapse-button":"card--card-collapse-button--2xu4xiOf","cardCollapseButton":"card--card-collapse-button--2xu4xiOf","isCollapse":"card--isCollapse--3K6_hJL8","isOpen":"card--isOpen--d_Z6roUa","isStretch":"card--isStretch--3NoHRLnH","isNoshadow":"card--isNoshadow--ZFfbtOYd","loader":"card--loader--1rpv_fs0"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Card/card.scss
// module id = 625
// module chunks = 0